// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gray{color:#292727}.time-bar{position:absolute;z-index:1;width:100%;height:2px;background-color:#555}.time-bar::before{content:'';display:block;position:absolute;width:0.75rem;height:0.75rem;top:50%;transform:translate(-50%, -50%);border-radius:50%;background-color:#555}\n", ""]);
// Exports
module.exports = exports;
